import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const MembershipInfo = ({
	premiumOffer,
	membershipTypeCode,
	membershipListData
}) => {
	return (
		<Stack justifyContent='space-between' gap={3} alignItems='center'>
			<img
				src={membershipListData?.logo}
				alt={membershipListData.name}
				width={280}
			/>
			<Stack gap={2}>
				<Typography fontStyle='italic'>{membershipListData?.blurb}</Typography>
				{membershipTypeCode === 'FTO' && (
					<Typography>
						{t('membershipInfo:ftoMessage')}{' '}
						<Typography component='span' fontWeight='bold'>
							{premiumOffer}
						</Typography>
					</Typography>
				)}
				{membershipTypeCode === 'FTOBILL' && (
					<Typography>{t('membershipInfo:ftoBillMessage')}</Typography>
				)}
			</Stack>
		</Stack>
	);
};

MembershipInfo.propTypes = {
	membershipListData: PropTypes.object,
	premiumOffer: PropTypes.string,
	membershipTypeCode: PropTypes.string,
	t: PropTypes.func
};

export default withTranslation('MembershipInfo')(MembershipInfo);
